import React from "react";
import { Icon } from "@bookingcom/bui-react";
import styles from "./FareFeatureIcon.module.css";
const FareFeatureIcon = ({ icon, isLarge, inline, color }) => {
    return (React.createElement("div", { className: styles.featureIconWrapper },
        React.createElement(Icon, { className: inline ? "" : styles.fixedWidth, size: isLarge ? "large" : "medium", svg: icon, color: color ?? "neutral" })));
};
export default FareFeatureIcon;
